(function () {
  "use strict";

  // ── Image update ───────────────────────────────────────────────────────────

  function updateImages(productCard, swatch) {
    const image1 = swatch.getAttribute("data-image-1");
    const image2 = swatch.getAttribute("data-image-2");

    const primaryImage = productCard.querySelector(".product-card__image--primary");
    const secondaryImage = productCard.querySelector(".product-card__image--secondary");

    if (primaryImage && image1) {
      primaryImage.src = image1;
      primaryImage.srcset = "";
    }

    if (secondaryImage) {
      secondaryImage.src = image2 || image1 || "";
      secondaryImage.srcset = "";
    }
  }

  // ── Price update ───────────────────────────────────────────────────────────

  function updatePrice(productCard, swatch) {
    const template = swatch.querySelector(".price-template");
    if (!template) return;

    const priceList = productCard.querySelector("price-list");
    if (priceList) {
      priceList.outerHTML = template.innerHTML;
    }
  }

  // ── Card meta update (links, colour label, tracking attrs) ─────────────────

  function updateCardMeta(productCard, swatch) {
    const productUrl = swatch.getAttribute("data-product-url");
    const productHandle = swatch.getAttribute("data-product-handle");
    const productId = swatch.getAttribute("data-product-id");
    const color = swatch.getAttribute("data-color");

    if (productUrl) {
      productCard.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        link.href = productUrl;
      });
    }

    const colorNameEl = productCard.querySelector(".color_name");
    if (colorNameEl && color) colorNameEl.textContent = color;

    if (productHandle) productCard.setAttribute("data-current-product-handle", productHandle);
    if (productId) productCard.setAttribute("data-current-product-id", productId);

    return {productId, productHandle};
  }

  // ── Lazily hydrate a colour's quick-selection markup from its <template> ───
  // Non-active colours ship as inert <template> tags (see product-card.liquid) so their
  // per-size buy-forms never enter the live DOM until that colour is actually selected.

  function hydrateColorGroup(quickSelection, productId) {
    if (quickSelection.querySelector(`.swatches_kopstorm_inner[data-product-id="${productId}"]`)) return;

    const template = quickSelection.querySelector(`template.swatches_kopstorm_template[data-product-id="${productId}"]`);
    if (!template) return;

    quickSelection.insertBefore(template.content.cloneNode(true), template);
    template.remove();
  }

  // ── Quick selection panel update ───────────────────────────────────────────

  function updateQuickSelection(productCard, productId, productHandle) {
    const quickSelection = productCard.querySelector(".swatches_kopstorm");
    if (!quickSelection) return;

    hydrateColorGroup(quickSelection, productId);

    const allGroups = quickSelection.querySelectorAll(".swatches_kopstorm_inner");
    if (!allGroups.length) return;

    allGroups.forEach((g) => (g.style.display = "none"));

    const target = quickSelection.querySelector(`.swatches_kopstorm_inner[data-product-id="${productId}"]`);
    (target || allGroups[0]).style.display = "flex";

    quickSelection.setAttribute("data-current-product-id", productId);

    if (productHandle) {
      const modal = productCard.querySelector("quick-buy-modal");
      if (modal) modal.setAttribute("handle", productHandle);
    }
  }

  // ── Full card state update — called on both hover and click ────────────────

  function applySwatchState(productCard, swatch, swatches) {
    swatches.forEach((s) => s.classList.remove("product-card-swatch--active"));
    swatch.classList.add("product-card-swatch--active");

    updateImages(productCard, swatch);
    updatePrice(productCard, swatch);

    const {productId, productHandle} = updateCardMeta(productCard, swatch);

    if (productId) {
      updateQuickSelection(productCard, productId, productHandle);
    }
  }

  // ── Quick-selection size clicks ─────────────────────────────────────────────
  // Each size is a plain span with data-variant-id (see product-card.liquid); clicking
  // one sets the hidden id input on the shared per-colour form and submits it via the
  // existing product-form custom element, which does the /cart/add.js fetch in the
  // background — no page reload, and no per-size form needed.

  function initQuickSelectSizeClicks(productCard) {
    const quickSelection = productCard.querySelector(".swatches_kopstorm");
    if (!quickSelection) return;

    quickSelection.addEventListener("click", (event) => {
      const sizeCard = event.target.closest(".card[data-variant-id]");
      if (!sizeCard) return;

      const group = sizeCard.closest(".swatches_kopstorm_inner");
      const form = group?.querySelector('form[action*="/cart/add"]');
      const idInput = form?.querySelector('input[name="id"]');
      if (!form || !idInput) return;

      idInput.value = sizeCard.getAttribute("data-variant-id");
      form.requestSubmit();
    });
  }

  // ── Init a single product card ─────────────────────────────────────────────

  function initCard(productCard) {
    if (productCard.hasAttribute("data-swatches-initialized")) return;
    productCard.setAttribute("data-swatches-initialized", "true");

    initQuickSelectSizeClicks(productCard);

    const container = productCard.querySelector(".product-card-swatches");
    if (!container) return;

    const swatches = Array.from(container.querySelectorAll(".product-card-swatch"));
    if (!swatches.length) return;

    // ── Mobile quick buy open / close ─────────────────────────────────────
    const trigger = productCard.querySelector(".mobile_quickbuy_trigger");
    const closeButton = productCard.querySelector(".close_button");

    if (trigger) {
      trigger.addEventListener("click", () => productCard.classList.add("quickbuy-active"));
    }
    if (closeButton) {
      closeButton.addEventListener("click", () => productCard.classList.remove("quickbuy-active"));
    }

    // ── Quick selection show/hide on figure hover (desktop only) ──────────
    const figure = productCard.querySelector(".product-card__figure");
    const quickSelect = productCard.querySelector(".swatches_kopstorm");

    if (figure && quickSelect) {
      figure.addEventListener("mouseover", () => {
        if (window.innerWidth > 700) quickSelect.style.display = "block";
      });
      figure.addEventListener("mouseout", () => {
        if (window.innerWidth > 700) quickSelect.style.display = "none";
      });
    }

    // ── Swatch events ─────────────────────────────────────────────────────
    // mouseenter → becomes active immediately, all card data updates
    // no mouseleave revert — last hovered swatch stays active
    // click → same behaviour, also covers touch devices
    swatches.forEach((swatch) => {
      swatch.addEventListener("mouseenter", function () {
        applySwatchState(productCard, this, swatches);
      });

      swatch.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        applySwatchState(productCard, this, swatches);
      });
    });

    // ── Set initial active state on load ────────────────────────────────
    const initialActive = swatches.find((s) => s.classList.contains("product-card-swatch--active")) || swatches[0];
    if (initialActive) {
      applySwatchState(productCard, initialActive, swatches);
    }
  }

  // ── Init all cards currently on the page ───────────────────────────────────

  function initAllCards() {
    document.querySelectorAll(".product-card").forEach(initCard);
  }

  // ── MutationObserver — picks up cards added by infinite scroll ─────────────

  function observeNewCards() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.(".product-card")) initCard(node);
          node.querySelectorAll?.(".product-card").forEach(initCard);
        });
      });
    });

    observer.observe(document.querySelector("main") || document.body, {childList: true, subtree: true});
  }

  // ── Boot ───────────────────────────────────────────────────────────────────

  function boot() {
    initAllCards();
    observeNewCards();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();



function RenderCartSlider() {
  //console.log("cart_rec_slider");
  const cartSliderEl = document.querySelector(".cart_rec_slider");
  if (cartSliderEl) {
    // ✅ bfcache fix: destroy any existing Swiper instance before re-initializing,
    // otherwise back-navigation restores a dead/duplicated instance
    if (cartSliderEl.swiper) {
      cartSliderEl.swiper.destroy(true, true);
    }

    const pdpUpsellsSwiper = new Swiper(".cart_rec_slider", {
      slidesPerView: 3,
      spaceBetween: 10, // You can adjust this for spacing between slides
      loop: false, // Equivalent to infinite scrolling
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        400: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 3,
        },
        610: {
          slidesPerView: 4,
        },
      },
    });
    cartSliderEl.style.opacity = 1;
  }
}

function RenderPreOrder(preOrderElement, preOrderButton) {
  //console.log("RenderPreOrder");
  if (!preOrderElement) return;
  const dataUrl = preOrderElement.getAttribute("data-url");

  if (dataUrl) {
    fetch(dataUrl)
      .then((response) => response.json())
      .then((data) => {
        // Store response in a variable
        let jsonResponsePreOrder = data;

        let PreOrderVariant = jsonResponsePreOrder.variants.find(
          (variant) => variant.title == document.querySelector(".seletect-variant-id").getAttribute("data-title"),
        );
        document.querySelector('.custom-pre-order [name="id"]').value = PreOrderVariant.id;

        if (preOrderButton) {
          preOrderButton.addEventListener("click", function () {
            document.querySelector('form.custom-pre-order button[type="submit"]').click();
          });
        }

        // You can use jsonResponse as needed here
      })
      .catch((error) => console.error("Error fetching data:", error));
  }
}



function RenderTagLinks() {
  const facetform = document.querySelectorAll("facets-form form");
  document.querySelectorAll(".collection_product_tags a").forEach((taglink) => {
    taglink.addEventListener("click", (e) => {
      e.preventDefault();
      if (facetform) {
        facetform.forEach((form) => {
          form.setAttribute("action", taglink.getAttribute("href"));
        });
      }
      const checkbox = document.querySelector('[name="filter.v.availability"]');

      if (checkbox) {
        // checkbox.checked = false; // Toggle or set true/false
        checkbox.dispatchEvent(new Event("change", {bubbles: true}));
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", function (event) {
  //console.log("DOM fully loaded and parsed");

  RenderTagLinks();
  RenderCartSlider();


  document.addEventListener("cart:refresh", (event) => {
   // console.log("cart:refresh");
    setTimeout(function () {
      RenderCartSlider();
    }, 1000);
  });
  document.addEventListener("cart:change", (event) => {
    //console.log("cart:change");
    setTimeout(function () {
      RenderCartSlider();
    }, 1000);
  });
  document.addEventListener("cart:prepare-bundled-sections", (event) => {
    //console.log("cart:prepare-bundled-sections");
    setTimeout(function () {
      RenderCartSlider();
    }, 1000);
  });

  if (document.querySelector(".varient_slider")) {
    const varientSlider = new Swiper(".varient_slider", {
      slidesPerView: 6.5, // Default for mobile
      spaceBetween: 3,
      freeMode: true, // Enables free scrolling
      freeModeMomentum: true, // Adds momentum for natural feel
      freeModeMomentumRatio: 1, // Controls momentum strength
      freeModeMomentumVelocityRatio: 0.5, // Controls speed of momentum
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // Tablet and up: maintain your original settings
        768: {
          slidesPerView: 7.5,
          spaceBetween: 5,
          freeMode: false, // Disable free mode on larger screens
        },
        992: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
        1200: {
          slidesPerView: 8.5,
          spaceBetween: 5,
          freeMode: false,
        },
      },
      // Optional: Disable navigation buttons on mobile if not needed
      on: {
        init: function () {
          if (window.innerWidth < 768) {
            //this.navigation.destroy();
          }
        },
        resize: function () {
          if (window.innerWidth < 768) {
            // this.navigation.destroy();
          } else {
            // this.navigation.init();
          }
        },
      },
    });

    // Get all slides as an array
    const slides = Array.from(varientSlider.slides);

    // Sort slides based on data-index attribute
    slides.sort((a, b) => {
      const indexA = parseInt(a.getAttribute("data-index")) || 6;
      const indexB = parseInt(b.getAttribute("data-index")) || 6;
      return indexA - indexB; // Ascending order (use indexB - indexA for descending)
    });

    // Remove all existing slides
    varientSlider.removeAllSlides();

    // Append sorted slides
    slides.forEach((slide) => varientSlider.appendSlide(slide));

    // Update Swiper to reflect changes
    varientSlider.update();

    document.querySelector(".cust_swatches").removeAttribute("style");
    const activeSlideIndex = Array.from(document.querySelectorAll(".varient_slider .swiper-slide")).findIndex((slide) =>
      slide.classList.contains("activeslide"),
    );
    //varientSlider.slideTo(activeSlideIndex);
  }

  let preOrderElement = document.querySelector(".custom-pre-order");

  const addToCartButton = document.querySelector('product-form button[type="submit"]');
  document.addEventListener("variant:change", function (event) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');
    // console.log(event.detail);

    if (document.querySelector(".seletect-variant-id")) {
      document.querySelector(".seletect-variant-id").setAttribute("data-title", event.detail.variant.title);
    }
    RenderPreOrder(preOrderElement, preOrderButton);
    //CustomWaisted();
    BundleProductLink();
    SizePagePopup();
  });

  document.addEventListener("facet:update", function (event) {
    // Wait for the actual filtered grid to land in the DOM instead of
    // guessing with a fixed delay — on slow connections the section swap
    // (theme.js) can take longer than a fixed timeout, which left infinite
    // scroll bound to the old, about-to-be-removed grid and silently dead.
    const container = document.querySelector("main") || document.body;
    let settled = false;

    const finish = () => {
      if (settled) return;
      settled = true;
      mutationObserver.disconnect();
      clearTimeout(fallbackTimer);
      RenderTagLinks();
      RenderInfiniteProduct?.();
    };

    const mutationObserver = new MutationObserver((mutations) => {
      const gridReplaced = mutations.some((m) =>
        Array.from(m.addedNodes).some(
          (node) => node.nodeType === 1 && (node.matches?.(".product-list") || node.querySelector?.(".product-list"))
        )
      );
      if (gridReplaced) finish();
    });

    mutationObserver.observe(container, {childList: true, subtree: true});

    // Safety net in case the section markup doesn't match the expected shape.
    const fallbackTimer = setTimeout(finish, 2500);
  });

  if (document.querySelector(".pdp-upsells")) {
    document.querySelectorAll(".upsell-img-slider").forEach((slider, index) => {
      const nextEl = slider.querySelector(".swiper-button-next");
      const prevEl = slider.querySelector(".swiper-button-prev");

      const options = {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        watchOverflow: true,
      };

      if (nextEl && prevEl) {
        options.navigation = {
          nextEl,
          prevEl,
        };
      }

      new Swiper(slider, options);
    });
  }
  //console.log('preOrderElement', preOrderElement);
  if (preOrderElement) {
    let preOrderButton = document.querySelector('.custom-pre-order button[type="button"]');

    RenderPreOrder(preOrderElement, preOrderButton);
  }
});

// Feature Fact Swiper JS
if (document.querySelector(".feature_fact_slider")) {
  var swiper = new Swiper(".feature_fact_slider", {
    slidesPerView: 1.2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2.4,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
  document.querySelector(".features_fact").removeAttribute("style");
}
if (document.querySelector(".upsell-img-slider")) {
  var swiper = new Swiper(".upsell-img-slider", {
    speed: 300,
    delay: 20,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
const showFeatureFacts = document.querySelectorAll(".show_ff_content");

if (showFeatureFacts) {
  showFeatureFacts.forEach((button) => {
    button.addEventListener("click", function () {
      button.parentNode.classList.toggle("active");
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const productSelect = document.querySelectorAll(".product_list_upsell");

  // Function to fetch product variants
  async function fetchProductVariants(productHandle) {
    try {
      // Shopify AJAX API endpoint to fetch product data
      const response = await fetch(`${productHandle}.js`);
      const product = await response.json();
      return product.variants;
    } catch (error) {
      console.error("Error fetching product variants:", error);
      return [];
    }
  }

  // Function to update variant dropdown
  function updateVariantDropdown(variants, variantSelectOption) {
    // Clear existing options
    const variantSelect = variantSelectOption.nextElementSibling;
    //console.log(variantSelect);
    if (!variantSelect) return; // Ensure the select element exists
    variantSelect.innerHTML = "";

    // Populate new options
    variants.forEach((variant) => {
      const option = document.createElement("option");
      option.value = variant.id;
      option.textContent = variant.title;
      if (!variant.available) {
        option.disabled = true;
        option.style.textDecoration = "line-through";
        option.textContent += " (sold out)";
      }
      variantSelect.appendChild(option);
    });
  }

  // Event listener for product selection change
  if (productSelect) {
    productSelect.forEach((select) => {
      select.addEventListener("change", async () => {
        const selectedProductHandle = select.value;
        if (selectedProductHandle) {
          const variants = await fetchProductVariants(selectedProductHandle);
          updateVariantDropdown(variants, select);
        }
      });
    });
  }

  document.addEventListener("recommendations:change", function (event) {
    //console.log("recommendations changed");
  });

  const custSwatches = document.querySelector(".cust_swatches");
  const dynamicColor = document.querySelector(".dynamic_color");

  if (custSwatches && dynamicColor) {
    const container = document.querySelector(".varient_info_wrapper"); // the wrapper around all swatches
    const items = Array.from(container.querySelectorAll(".product_swatch_box_container"));

    // sort by data-index (numerically)
    items.sort((a, b) => +a.dataset.index - +b.dataset.index);

    // re-append sorted elements to the DOM
    items.forEach((item) => container.appendChild(item));

    const swatchBoxes = custSwatches.querySelectorAll(".product_swatch_box_container");

    function updateActiveColor() {
      const active = custSwatches.querySelector(".product_swatch_box_container.activeslide");
      if (active) {
        const color = active.getAttribute("data-color");
        dynamicColor.textContent = color;
      }
    }

    // Run once on load
    updateActiveColor();

    swatchBoxes.forEach((box) => {
      box.addEventListener("mouseenter", () => {
        const hoverColor = box.getAttribute("data-color");
        if (hoverColor) {
          dynamicColor.textContent = hoverColor;
        }
      });

      box.addEventListener("mouseleave", () => {
        updateActiveColor();
      });
    });
  }

  expandable_icon(true);
  //CustomWaisted();
  BundleProductLink();
});

function expandable_icon(trigger = false) {
  if (document.querySelectorAll(".expandable_icon").length > 0) {
    document.querySelectorAll(".expandable_icon").forEach((icon) => {
      const toggle = () => {
        icon.classList.toggle("active");
        icon.querySelector(".scale_text_container")?.classList.toggle("show");
      };

      icon.addEventListener("click", function (event) {
        event.stopPropagation();
        toggle();
      });

      if (trigger) {
        // Simulate initial click — call the toggle directly rather than
        // dispatching a real click event: a dispatched event with
        // bubbles:true (or even bubbles:false, since capture-phase
        // listeners on document run before it reaches this element
        // regardless of the bubbles flag) is visible to the theme's
        // global "click outside closes any open overlay" listener,
        // which was closing the cart drawer if it happened to be open
        // when this fired.
        toggle();

        // Simulate click again after 6 seconds
        setTimeout(toggle, 6000);
      }
    });
  }
}

/* ===============================
   Waist Switcher Init
================================ */
function CustomWaisted() {
  const switcher = document.querySelector(".waist-switcher");
  if (!switcher) return;

  switcher.querySelectorAll("li").forEach((item) => {
    item.addEventListener("click", async () => {
      if (item.classList.contains("active")) return;

      const waist = item.innerText?.trim();
      if (!waist) return;

      window.selectedWaist = waist;

      setActiveWaist(item);
    });
  });

  // Restore state after rerender
  if (window.selectedWaist) {
    const li = [...switcher.querySelectorAll("li")].find((el) => el.innerText.trim() === window.selectedWaist);

    if (li) setActiveWaist(li);
  }

  /* ===============================
    Apply Waist Selection
  ================================ */
  async function setActiveWaist(activeItem) {
    document.querySelectorAll(".waist-switcher li").forEach((li) => {
      li.classList.toggle("active", li === activeItem);
    });

    const checkPreoder = document.querySelector(".custom-pre-order");
    if (checkPreoder) {
      if (activeItem.innerText.trim() == "High") {
        checkPreoder.style.display = "none";
      } else {
        checkPreoder.style.display = "block";
      }
    }

    /* ---- Variant update ---- */
    const idInput = document.querySelector('product-rerender [name="id"]');
    if (idInput && activeItem.dataset.variant) {
      idInput.value = activeItem.dataset.variant;
      idInput.dispatchEvent(new Event("change", {bubbles: true}));
    }

    /* ---- Gallery swap ---- */
    if (activeItem.dataset.handle) {
      await replaceProductGallery(activeItem.dataset.handle);
    }
  }

  /* ===============================
    Replace Product Gallery
  ================================ */
  function replaceImagesOnly(currentEl, newEl) {
    if (!currentEl || !newEl) return;

    const currentImgs = currentEl.querySelectorAll("img");
    const newImgs = newEl.querySelectorAll("img");

    newImgs.forEach((newImg, index) => {
      const currentImg = currentImgs[index];
      if (!currentImg) return;

      // Clone to avoid moving nodes
      const clonedImg = newImg.cloneNode(true);

      // Preserve lazy/loading state if needed
      clonedImg.loading = currentImg.loading || "lazy";

      currentImg.replaceWith(clonedImg);
    });
  }

  function replaceMediaInnerContent(currentEl, newEl) {
    if (!currentEl || !newEl) return;

    const currentMediaItems = currentEl.querySelectorAll(".product-gallery__media");
    const newMediaItems = newEl.querySelectorAll(".product-gallery__media");

    newMediaItems.forEach((newMedia, index) => {
      const currentMedia = currentMediaItems[index];
      if (!currentMedia) return;

      /* -------------------------------
       Replace IMG
    -------------------------------- */
      const currentImg = currentMedia.querySelector("img");
      const newImg = newMedia.querySelector("img");

      if (currentImg && newImg) {
        currentImg.replaceWith(newImg.cloneNode(true));
      }

      /* -------------------------------
       Replace / Sync scale badge
    -------------------------------- */
      const currentBadge = currentMedia.querySelector(".scale_badge_container");
      const newBadge = newMedia.querySelector(".scale_badge_container");

      if (newBadge) {
        if (currentBadge) {
          currentBadge.replaceWith(newBadge.cloneNode(true));
        } else {
          // Insert badge after image if missing
          currentMedia.appendChild(newBadge.cloneNode(true));
        }
      } else if (currentBadge) {
        // Remove old badge if new product doesn't have one
        currentBadge.remove();
      }
    });
  }

  async function replaceProductGallery(handle) {
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", {bubbles: true}));

    const currentCarousel = document.querySelector("scroll-carousel");
    const currentNav = document.querySelector("product-gallery-navigation");

    if (!currentCarousel || !currentNav || !handle) return;

    try {
      const res = await fetch(`/products/${handle}?view=ajax`);
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, "text/html");

      const newCarousel = doc.querySelector("scroll-carousel");
      const newNav = doc.querySelector("product-gallery-navigation");

      if (!newCarousel || !newNav) return;

      /* ----------------------------------
       Replace ONLY carousel images
    ---------------------------------- */
      replaceMediaInnerContent(currentCarousel, newCarousel);

      /* ----------------------------------
       Replace ONLY thumbnail images
    ---------------------------------- */
      replaceImagesOnly(currentNav, newNav);

      if (typeof expandable_icon === "function") {
        expandable_icon();
      }

      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", {bubbles: true}));
    } catch (err) {
      console.error("Gallery replace failed", err);
    }
  }
}

let _infiniteScrollTeardown = null;

function RenderInfiniteProduct() {
  // Tear down any previous instance (e.g. from a prior filter change) before
  // binding a new one, so observers/loaders don't stack up across facet updates.
  if (_infiniteScrollTeardown) {
    _infiniteScrollTeardown();
    _infiniteScrollTeardown = null;
  }

  const grid = document.querySelector(".product-list");
  const pagination = document.querySelector(".pagination");
  if (!grid || !pagination) return;

  let loading = false;
  let nextPageUrl = pagination.querySelector("a[rel='next']")?.href || null;

  pagination.style.display = "none";

  // Loader element
  const loader = document.createElement("div");
  loader.id = "infinite-loader";
  loader.style.cssText = "text-align:center; padding:20px 0; min-height:1px;";
  loader.innerHTML = `
  <style>
    #infinite-loader .loader-dots {
      display: inline-flex;
      gap: 6px;
      align-items: center;
    }
    #infinite-loader .loader-dots span {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #333;
      animation: dotBounce 1.2s infinite ease-in-out;
    }
    #infinite-loader .loader-dots span:nth-child(1) { animation-delay: 0s; }
    #infinite-loader .loader-dots span:nth-child(2) { animation-delay: 0.2s; }
    #infinite-loader .loader-dots span:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
      0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
      40%            { transform: scale(1.2); opacity: 1;   }
    }
  </style>
  <div class="loader-dots">
    <span></span>
    <span></span>
    <span></span>
  </div>
`;
  grid.insertAdjacentElement("afterend", loader);

  const setLoaderState = (state) => {
    const dots = loader.querySelector(".loader-dots");
    const existingError = loader.querySelector(".error-msg");

    // Clean up error msg if present
    if (existingError) existingError.remove();

    if (state === "loading") {
      if (dots) dots.style.visibility = "visible";
    } else if (state === "error") {
      if (dots) dots.style.visibility = "hidden";
      const errorMsg = document.createElement("p");
      errorMsg.className = "error-msg";
      errorMsg.innerHTML = `Failed to load products. <button id='retry-btn'>Retry</button>`;
      loader.appendChild(errorMsg);
      document.getElementById("retry-btn")?.addEventListener("click", loadMore);
    } else {
      if (dots) dots.style.visibility = "hidden";
    }
  };

  // ✅ Hide sold-out products initially
  const hideSoldOut = () => {
    grid.querySelectorAll(".sold_out_prod").forEach((card) => {
      card.style.display = "none";
    });
  };

  // ✅ Show and push sold-out products to the end (called only when all pages loaded)
  const pushSoldOutToEnd = () => {
    const allCards = [...grid.querySelectorAll(".product-card")];
    const available = allCards.filter((card) => !card.classList.contains("sold_out_prod"));
    const soldOut = allCards.filter((card) => card.classList.contains("sold_out_prod"));

    soldOut.forEach((card) => (card.style.display = "")); // ✅ Unhide
    [...available, ...soldOut].forEach((card) => grid.appendChild(card));
  };

  const loadMore = async () => {
    if (!nextPageUrl || loading) return;

    loading = true;
    setLoaderState("loading");

    // Watchdog: if the request ever hangs (e.g. flaky connection or a
    // server that never responds), `loading` would otherwise stay true
    // forever and permanently block every future scroll/observer trigger.
    const watchdog = new AbortController();
    const watchdogTimer = setTimeout(() => watchdog.abort(), 15000);

    try {
      const response = await fetch(nextPageUrl, {signal: watchdog.signal});
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newProducts = doc.querySelector(".product-list");
      const newPagination = doc.querySelector(".pagination");

      if (newProducts) {
        // Hide sold-out cards within just this batch before inserting, instead
        // of re-scanning the whole (ever-growing) grid on every batch — that
        // scan was O(n) per batch, i.e. O(n^2) over a long scroll session,
        // and was the main cause of the browser hanging on long scrolls.
        const batch = document.createElement("div");
        batch.innerHTML = newProducts.innerHTML;
        batch.querySelectorAll(".sold_out_prod").forEach((card) => {
          card.style.display = "none";
        });
        while (batch.firstChild) grid.appendChild(batch.firstChild);
      }

      nextPageUrl = newPagination?.querySelector("a[rel='next']")?.href ?? null;
      setLoaderState("hidden");

      if (!nextPageUrl) {
        stopWatching();
        pushSoldOutToEnd();
      }
    } catch (err) {
      console.error("Infinite scroll error:", err);
      setLoaderState("error");
    } finally {
      clearTimeout(watchdogTimer);
      loading = false;
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        loadMore();
      }
    },
    {rootMargin: "0px 0px 1200px 0px"},
  );

  observer.observe(loader);

  // Fallback for dragging the scrollbar thumb straight to the bottom: that
  // jump can skip past the loader's 1200px trigger zone in one motion
  // (especially with a footer/other sections below the grid), landing the
  // user at the true bottom with the loader already scrolled out of view
  // above them and no further room to scroll to re-trigger it. Checking the
  // actual document scroll position — not just the sentinel element — catches
  // that case regardless of how the user reached the bottom.
  let scrollCheckQueued = false;
  const checkNearBottom = () => {
    scrollCheckQueued = false;
    if (loading || !nextPageUrl) return;
    const distanceFromBottom = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight);
    if (distanceFromBottom < 1200) loadMore();
  };
  const onScroll = () => {
    if (scrollCheckQueued) return;
    scrollCheckQueued = true;
    requestAnimationFrame(checkNearBottom);
  };

  window.addEventListener("scroll", onScroll, {passive: true});
  window.addEventListener("resize", onScroll, {passive: true});
  checkNearBottom();

  const stopWatching = () => {
    observer.disconnect();
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onScroll);
  };

  _infiniteScrollTeardown = () => {
    stopWatching();
    loader.remove();
  };

  // ✅ Sort sold-out products on initial load
  //pushSoldOutToEnd();
  //hideSoldOut();
}

/* =====================================================
   CONFIG
===================================================== */

/* ============================
   MILESTONES
============================ */

const MILESTONES = [
  {type: "qty", goalQty: 2, key: "b2g1"}, // Buy 2 Get 1 Free
  {type: "amount", goal: 90, key: "gift1"},
  {type: "amount", goal: 125, key: "gift2"},
  {type: "amount", goal: 160, key: "gift3"},
  //{type: "amount", goal: 190, key: "gift4"},
];

/* ============================
   FREE GIFT PRODUCT IDS
============================ */

const FREE_GIFT_PRODUCT_IDS = ["free-thrivin-silk-socks-white", "cap-dark-mauve", "headband-cream", "cap-cream", "headband-night-black"];

/* ============================
   MILESTONE → GIFT MAPPING
============================ */

const MILESTONE_GIFT_MAP = {
  gift1: ["headband-night-black"],
  gift2: ["free-thrivin-silk-socks-white"],
  gift3: ["cap-dark-mauve", "cap-cream"],
  //gift4: ["free-thrivin-silk-socks-white"]
};

/* =====================================================
   CART HELPERS
===================================================== */

let CURRENT_CART = null;
let FREE_GIFT_PRODUCTS = [];

function convertToEUR(amountInMinor) {
  if (Shopify?.currency?.rate) {
    return Number(amountInMinor) / 100 / Shopify.currency.rate;
  }
  return 0;
}

async function getCart() {
  const res = await fetch("/cart.js");
  return await res.json();
}

async function fetchProductById(productId) {
  const res = await fetch(`/products/${productId}.js`);
  return await res.json();
}

let freeGiftProductsPromise = null;

function loadFreeGiftProducts() {
  // handleMilestones() can run concurrently (e.g. DOMContentLoaded and
  // cart-drawer:refreshed firing close together), and each path used to
  // start its OWN fetch loop over the same product handles since the old
  // `if (FREE_GIFT_PRODUCTS.length) return;` guard only checks state that's
  // set AFTER the first await — the second call would see it still empty
  // and duplicate every entry. Caching the in-flight promise means every
  // concurrent caller awaits the same single run instead of racing.
  if (freeGiftProductsPromise) return freeGiftProductsPromise;

  freeGiftProductsPromise = (async () => {
    if (FREE_GIFT_PRODUCTS.length) return;

    for (const id of FREE_GIFT_PRODUCT_IDS) {
      const product = await fetchProductById(id);
      if (product.available) {
        FREE_GIFT_PRODUCTS.push(product);
      }
    }
  })();

  return freeGiftProductsPromise;
}
/*
function getCartQty(cart) {
  return cart.items.reduce((sum, i) => sum + i.quantity, 0);
}
*/
function getCartQty(cart) {
  return cart.items.reduce((sum, i) => {
    // Exclude the free gift from progress bar count
    if (i.product_title?.includes('Our Birthday Gift for You') || i.product_title?.includes('Our Gift for You')) return sum;

    // Exclude any line carrying a "Bundle & Save" discount
  //  if (hasBundleSave(i)) return sum;

    return sum + i.quantity;
  }, 0);
}

function hasBundleSave(item) {
  const re = /Bundle.*Save/i; // matches "Bundle & Save" and "Bundle &amp; Save"
  return (item.discounts || []).some(d => re.test(d.title || ''))
    || (item.line_level_discount_allocations || []).some(a => re.test(a?.discount_application?.title || ''));
}

/* =====================================================
   MILESTONE LOGIC
===================================================== */

function getReachedMilestones(cart, spentInEUR) {
  const qty = getCartQty(cart);

  return MILESTONES.filter((m) => {
    if (m.type === "qty") return qty >= m.goalQty;
    return spentInEUR >= m.goal;
  });
}

function getGiftForMilestone(cart, milestoneKey) {
  return cart.items.find((item) => item.properties?._free_gift === "true" && item.properties?._milestone === milestoneKey);
}

/* =====================================================
   BANNER MESSAGE LOGIC
===================================================== */

function updateMilestoneUI(spentInEUR) {
  const banner = document.getElementById("free-shipping-banner");
  if (!banner || !CURRENT_CART) return;

  const qty = getCartQty(CURRENT_CART);

  // Step 1 → encourage adding items for Buy 2 Get 1
  if (qty < 2) {
    banner.innerHTML = `Add <b>${2 - qty}</b> more item(s) to unlock <b>Buy 2 Get 1 Free</b>`;
    return;
  }

  if (qty === 2) {
    banner.innerHTML = `Offer unlocked! Add 1 more item to get 1 free.`;
    return;
  }

  // Step 2 → progress through amount-based milestones
  for (let i = 0; i < MILESTONES.length; i++) {
    const m = MILESTONES[i];
    if (m.type !== "amount") continue;

    if (spentInEUR < m.goal) {
      const remaining = (m.goal - spentInEUR) * Shopify.currency.rate;

      if (m.key === "gift5") {
        banner.innerHTML = `Spend ${remaining.toFixed(2)} ${Shopify.currency.active} more for <b>FREE BRA</b>`;
      } else {
        banner.innerHTML = `Spend ${remaining.toFixed(2)} ${Shopify.currency.active} more to get a <b>FREE GIFT</b>`;
      }
      return;
    }
  }

  banner.innerHTML = `<b>All Rewards Unlocked 🎉</b>`;
}

/* =====================================================
   PROGRESS BAR
===================================================== */

function calculateSegmentedProgress(spentInEUR) {
  if (!CURRENT_CART) return 0;

  const qty = getCartQty(CURRENT_CART);
  const totalSegments = MILESTONES.length;
  let progressPercent = 0;

  for (let i = 0; i < MILESTONES.length; i++) {
    const m = MILESTONES[i];

    const prev = i === 0 ? 0 : MILESTONES[i - 1].type === "amount" ? MILESTONES[i - 1].goal : MILESTONES[i - 1].goalQty;

    if (m.type === "qty") {
      if (qty >= m.goalQty) {
        progressPercent += 100 / totalSegments;
      } else if (qty > prev) {
        const seg = (qty - prev) / (m.goalQty - prev);
        progressPercent += seg * (100 / totalSegments);
        break;
      } else break;
    } else {
      if (spentInEUR >= m.goal) {
        progressPercent += 100 / totalSegments;
      } else if (spentInEUR > prev) {
        const seg = (spentInEUR - prev) / (m.goal - prev);
        progressPercent += seg * (100 / totalSegments);
        break;
      } else break;
    }
  }

  return Math.min(progressPercent, 100);
}

function updateProgressBar(spentInEUR) {
  const progress = calculateSegmentedProgress(spentInEUR);

  document.querySelector(".milestone-line-inner")?.style.setProperty("--progress", progress + "%");

  const qty = getCartQty(CURRENT_CART);

  MILESTONES.forEach((m) => {
    const dot = document.querySelector(`.Euromilestore_${m.key}`);
    if (!dot) return;

    const reached = (m.type === "qty" && qty >= m.goalQty) || (m.type === "amount" && spentInEUR >= m.goal);

    reached ? dot.classList.add("reached") : dot.classList.remove("reached");
  });
}

/* =====================================================
   REMOVE INVALID GIFTS
===================================================== */

async function removeInvalidGifts(cart, spentInEUR) {
  for (const m of MILESTONES) {
    if (m.type === "qty") continue;

    if (spentInEUR < m.goal) {
      const gift = getGiftForMilestone(cart, m.key);
      if (gift) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: {"Content-Type": "application/json"},
          body: JSON.stringify({id: gift.key, quantity: 0}),
        });
        window.location.reload();
      }
    }
  }
}

/* =====================================================
   FREE GIFT POPUP
===================================================== */

let activeMilestoneKey = null;
let selectedVariantId = null;

async function renderFreeGiftPopup(milestoneKey, cart) {
  activeMilestoneKey = milestoneKey;
  selectedVariantId = null;

  await loadFreeGiftProducts();

  const popup = document.getElementById("free-gift-popup");
  const list = popup.querySelector(".free-gift-list");
  const addBtn = document.getElementById("add-free-gift-btn");

  list.innerHTML = "";
  addBtn.disabled = true;

  addBtn.addEventListener("click", (e) => {
    // Lock immediately
    addBtn.innerText = "Adding your free gift…";
    setTimeout(function () {
      addBtn.disabled = true;
      addBtn.setAttribute("aria-busy", "true");
    }, 500);
  });

  // Filter products allowed for this specific milestone
  const allowedHandles = MILESTONE_GIFT_MAP[milestoneKey] || [];
  const filteredProducts = FREE_GIFT_PRODUCTS.filter((p) => allowedHandles.includes(p.handle));

  // Auto-select if only one product is available for this milestone
  const autoSelect = filteredProducts.length === 1;

  filteredProducts.forEach((product) => {
    const item = document.createElement("div");
    item.className = "free-gift-item";

    const radio = document.createElement("input");
    radio.type = "radio";
    radio.name = "free-gift";

    const img = document.createElement("img");
    img.src = product.featured_image + "&width=70";

    const imgDiv = document.createElement("div");
    imgDiv.className = "free-image";
    imgDiv.appendChild(img);

    const title = document.createElement("strong");
    title.innerText = product.title;

    const price = document.createElement("span");
    price.innerText = "Free";
    price.className = "free-label";

    const midDiv = document.createElement("div");
    midDiv.className = "free-midblock";
    midDiv.append(title, price);

    let variantSelect = null;

    if (product.variants.length > 1) {
      variantSelect = document.createElement("select");
      // Enable select immediately if auto-selecting (only one product choice)
      variantSelect.disabled = !autoSelect;

      product.variants.forEach((v) => {
        const opt = document.createElement("option");
        opt.value = v.id;
        opt.innerText = v.title;
        opt.disabled = !v.available;
        variantSelect.appendChild(opt);
      });

      variantSelect.addEventListener("change", () => {
        selectedVariantId = variantSelect.value;

        const giftvarintID = document.getElementById("add-free-gift-id");
        if (giftvarintID) giftvarintID.value = selectedVariantId;

        const gift__milestone = document.getElementById("gift__milestone");
        if (gift__milestone) gift__milestone.value = activeMilestoneKey;
      });
    }

    radio.addEventListener("change", () => {
      // Disable all other selects first
      document.querySelectorAll(".free-gift-item select").forEach((s) => s && (s.disabled = true));

      if (variantSelect) {
        variantSelect.disabled = false;
        selectedVariantId = variantSelect.value;
      } else {
        selectedVariantId = product.variants[0].id;
      }

      addBtn.disabled = false;

      const giftvarintID = document.getElementById("add-free-gift-id");
      if (giftvarintID) giftvarintID.value = selectedVariantId;

      const gift__milestone = document.getElementById("gift__milestone");
      if (gift__milestone) gift__milestone.value = activeMilestoneKey;
    });

    // Auto-select when only one product is available for this milestone
    if (autoSelect) {
      radio.checked = true;
      selectedVariantId = variantSelect ? variantSelect.value : product.variants[0].id;
      addBtn.disabled = false;

      const giftvarintID = document.getElementById("add-free-gift-id");
      if (giftvarintID) giftvarintID.value = selectedVariantId;

      const gift__milestone = document.getElementById("gift__milestone");
      if (gift__milestone) gift__milestone.value = activeMilestoneKey;
    }

    const radioDiv = document.createElement("div");
    radioDiv.className = "free-radio";
    radioDiv.appendChild(radio);

    item.append(imgDiv, midDiv, radioDiv);
    if (variantSelect) item.appendChild(variantSelect);

    list.appendChild(item);
  });

  popup.classList.add("show");
}

function openFreeGiftPopup(key, cart) {
  renderFreeGiftPopup(key, cart);
}

function closeFreeGiftPopup() {
  document.getElementById("free-gift-popup")?.classList.remove("show");
}

/* =====================================================
   CORE HANDLER
===================================================== */

async function handleMilestones() {
  const banner = document.getElementById("free-shipping-banner");
  if (!banner) return;

  // ✅ bfcache fix: always trust the live cart, never the server-rendered
  // data-total attribute — the DOM snapshot is stale after back-navigation
  const cart = await getCart();
  CURRENT_CART = cart;

  banner.dataset.total = cart.total_price; // keep DOM attribute in sync
  const spentInEUR = convertToEUR(cart.total_price);

  updateMilestoneUI(spentInEUR);
  updateProgressBar(spentInEUR);

  await removeInvalidGifts(cart, spentInEUR);

  // Skip popup for b2g1 — only trigger for amount-based gift milestones
  const pending = getReachedMilestones(cart, spentInEUR).find((m) => m.key !== "b2g1" && !getGiftForMilestone(cart, m.key));

  //console.log("pending", pending);

  if (pending) {
    openFreeGiftPopup(pending.key, cart);
  }

  const closePopBtn = document.getElementById("close-free-gift");
  //console.log("closePopBtn", closePopBtn);

  if (closePopBtn) {
    closePopBtn.addEventListener("click", () => {
      //console.log("closePopBtn1", closePopBtn);
      //console.log("closePopBtn2", document.getElementById("free-gift-popup"));
      document.getElementById("free-gift-popup")?.classList.remove("show");
    });
  }
}

/* =====================================================
   INIT
===================================================== */

document.addEventListener("DOMContentLoaded", () => {
  handleMilestones();
  RenderInfiniteProduct?.();
  SizePagePopup();
  ShopNowLook();
  SlideshowHotspots();

});

document.addEventListener("cart:change", () => {
  setTimeout(handleMilestones, 600);
  //close popup
});

/* =====================================================
   CART DRAWER RE-RENDER FIX
   -----------------------------------------------------
   The theme's <cart-drawer> component replaces its ENTIRE
   inner HTML with fresh server-rendered HTML on every
   cart:change / cart:refresh / pageshow (async fetch that
   resolves 1-2s later). That wipes the milestone bar's
   --progress, .reached dots, banner text, and kills the
   complementary products Swiper — which is why the bar
   "initializes once then clears after a few seconds".

   The theme dispatches "cart-drawer:refreshed" AFTER each
   replacement, so we re-apply our UI on that event.
===================================================== */

document.addEventListener("cart-drawer:refreshed", () => {
  handleMilestones();
  RenderCartSlider();
});

/* =====================================================
   BFCACHE FIX — back/forward navigation from checkout
   -----------------------------------------------------
   When customer goes to checkout and taps the browser
   back arrow, the page is restored from bfcache (or
   HTTP cache) — DOMContentLoaded does NOT fire again,
   and the restored DOM is stale (old cart totals, old
   complementary products). This handler re-syncs the
   milestone bar + cart drawer sections from live data.
===================================================== */

window.addEventListener("pageshow", async (event) => {
  const nav = performance.getEntriesByType("navigation")[0];
  const isBackNav = event.persisted || nav?.type === "back_forward";
  if (!isBackNav) return;

  try {
    // 1. Refresh milestone bar + progress from the live cart
    //    (handleMilestones now always fetches /cart.js itself)
    await handleMilestones();

    // 2. Ask the theme to re-render cart sections via the
    //    Section Rendering API — this refreshes
    //    .cart-drawer__complementary-products with fresh HTML.
    //    The existing cart:refresh listener also re-runs
    //    RenderCartSlider() after 1s.
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {bubbles: true}));
  } catch (err) {
    console.error("pageshow cart re-sync failed:", err);
  }
});

function BundleProductLink() {
  if (!window.bundleProductMap) return;

  const variantPicker = document.querySelector("variant-picker, .variant-picker");
  if (!variantPicker) return;
console.log("variantPicker 1");
  // Track which bundle items were matched to a variant picker legend
  const matchedLabels = new Set();

  // Render multi-variant bundle items (existing logic)
  document.querySelectorAll(".variant-picker__option legend").forEach((legend) => {
    legend.closest(".variant-picker__option").classList.add("bundle_variant");

    const labelText = legend.innerText
      .replace(/\(Size\):/gi, "")
      .replace(/\(Select your length\):/gi, "")
      .trim();
console.log("variantPicker 2");

    const product = window.bundleProductMap.find((item) => item.label.toLowerCase() === labelText.toLowerCase());
    if (!product) return;

    matchedLabels.add(product.label);
console.log("variantPicker 3");

    const wrapper = document.createElement("div");
    wrapper.style.display = "flex";
    wrapper.style.alignItems = "center";
    wrapper.style.gap = "10px";

    const [title, color] = product.label.split("|").map((s) => s.trim());

    wrapper.innerHTML = `
      <a href="/products/${product.handle}" target="_blank" class="mtch"
         style="display:flex;align-items:center;gap:10px;text-decoration:none;color:inherit">
        <img src="${product.image}" width="60" height="60" style="object-fit:cover">
        <div><strong>${title}</strong><br><span>Color: ${color}</span></div>
      </a>
    `;
console.log("variantPicker 41");

    legend.replaceWith(wrapper);
  });

  // Render unmatched bundle items (e.g. single-variant products like the Headband)
  const unmatched = window.bundleProductMap.filter(
    (item) => !matchedLabels.has(item.label)
  );

  if (unmatched.length === 0) return;

  // Build a container for the unmatched items, inserted BEFORE the variant picker



  unmatched.forEach((product) => {
    const unmatchedContainer = document.createElement("div");
    unmatchedContainer.classList.add("bundle_variant", "bundle_single_variant");
    const [title, color] = product.label.split("|").map((s) => s.trim());

    const item = document.createElement("div");
    item.style.display = "flex";
    item.style.alignItems = "center";
    item.style.gap = "10px";

    item.innerHTML = `
      <a href="/products/${product.handle}" target="_blank" class="unmtch"
         style="display:flex;align-items:center;gap:10px;text-decoration:none;color:inherit">
        <img src="${product.image}" width="60" height="60" style="object-fit:cover">
        <div><strong>${title}</strong><br><span>Color: ${color}</span></div>
      </a>
    `;

    unmatchedContainer.appendChild(item);
    variantPicker.insertBefore(unmatchedContainer, variantPicker.firstChild);
  });

  // Insert before the variant picker so it appears above the size selectors

}

// 02-02-2026

function SizePagePopup() {
  /* -----------------------------
       INDICATOR INIT
    ------------------------------ */
  document.querySelectorAll(".size_guide_group").forEach((group) => {
    const buttons = group.querySelectorAll(".size_guide_btn");
    const indicator = group.querySelector(".size_guide_indicator");

    if (!buttons.length || !indicator) return;

    function updateIndicator(btn) {
      const btnRect = btn.getBoundingClientRect();
      const groupRect = group.getBoundingClientRect();
      const x = btnRect.left - groupRect.left;

      indicator.style.width = btn.offsetWidth + "px";
      indicator.style.transform = `translateX(${x}px)`;
    }

    // Initial active
    let activeBtn = group.querySelector(".size_guide_active") || buttons[0];
    activeBtn.classList.add("size_guide_active");
    updateIndicator(activeBtn);

    // Click handlers
    buttons.forEach((btn) => {
      btn.addEventListener("click", function () {
        buttons.forEach((b) => b.classList.remove("size_guide_active"));
        btn.classList.add("size_guide_active");

        updateIndicator(btn);
      });
    });

    // Recalc on resize
    let resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const current = group.querySelector(".size_guide_active");
        if (current) updateIndicator(current);
      }, 100);
    });
  });

  const CM_TO_IN = 0.393701;

  /* -----------------------------
       CONTEXT DETECTOR (PAGE / POPUP)
    ------------------------------ */
  function getActiveContainer(btn) {
    // size page tab content
    let tabContent = btn.closest(".size_guide_content");
    if (tabContent) return tabContent;

    // popup
    let popup = btn.closest("#size_guide_popup");
    if (popup) return popup;

    // fallback
    return document;
  }

  /* -----------------------------
     SIZE SYSTEM TOGGLE (EU / US / UK)
  ------------------------------ */
  document.querySelectorAll(".sg_toggle_wrapper:nth-child(2) .size_guide_btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const group = btn.closest(".size_guide_group");

      // Active state
      group.querySelectorAll(".size_guide_btn").forEach((b) => b.classList.remove("size_guide_active"));
      btn.classList.add("size_guide_active");

      const system = btn.textContent.trim().toLowerCase(); // eu | us | uk
      const container = getActiveContainer(btn);

      // Change table heading
      container.querySelectorAll(".size-system-th").forEach((th) => {
        th.textContent = system.toUpperCase() + " SIZE";
      });

      // Change td values
      container.querySelectorAll(".sizr-td").forEach((td) => {
        const value = td.dataset[system];
        if (!value) return;

        td.innerHTML = `${value} <span class="size_guide_eu">${system.toUpperCase()}</span>`;
      });
    });
  });

  /* -----------------------------
     MEASUREMENT UNIT TOGGLE (cm / in)
  ------------------------------ */
  document.querySelectorAll(".sg_toggle_wrapper:nth-child(1) .size_guide_btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      // Active state
      btn.parentElement.querySelectorAll(".size_guide_btn").forEach((b) => b.classList.remove("size_guide_active"));
      btn.classList.add("size_guide_active");

      const unit = btn.textContent.trim(); // cm | in
      const container = getActiveContainer(btn);

      container.querySelectorAll(".size_guide_table tbody tr").forEach((row) => {
        row.querySelectorAll(".cm_in").forEach((cell) => {
          if (!cell.dataset.cm) {
            cell.dataset.cm = cell.textContent.trim();
          }

          if (unit === "cm") {
            cell.textContent = cell.dataset.cm;
          } else {
            cell.textContent = convertRange(cell.dataset.cm);
          }
        });
      });
    });
  });

  /* -----------------------------
     RANGE CONVERTER (88–94 → 35–37)
  ------------------------------ */
function convertRange(value) {
  if (!value) return "";

  if (value.includes("–") || value.includes("-")) {
    const [min, max] = value.split(/[–-]/).map((v) => parseFloat(v));
    return `${toIn(min)}–${toIn(max)}`;
  }
  return toIn(parseFloat(value));
}

function toIn(cm) {
  return Math.round(cm * CM_TO_IN);
}

  /* -----------------------------
     RE-INIT INDICATOR (PAGE + POPUP)
  ------------------------------ */
  function reInitIndicators(scope) {
    scope.querySelectorAll(".size_guide_group").forEach((group) => {
      const buttons = group.querySelectorAll(".size_guide_btn");
      const indicator = group.querySelector(".size_guide_indicator");

      if (!buttons.length || !indicator) return;

      const activeBtn = group.querySelector(".size_guide_active") || buttons[0];
      if (!activeBtn) return;

      const btnRect = activeBtn.getBoundingClientRect();
      const groupRect = group.getBoundingClientRect();
      const x = btnRect.left - groupRect.left;

      indicator.style.width = activeBtn.offsetWidth + "px";
      indicator.style.transform = `translateX(${x}px)`;
    });
  }

  /* tab change (size page) */
  document.addEventListener("click", function (e) {
    const tab = e.target.closest(".size_guide_tab");
    if (!tab) return;

    setTimeout(() => {
      reInitIndicators(document);

      // cm/in sync for active tab
      const activeContent = document.querySelector(".size_guide_content.sg_current");
      if (!activeContent) return;

      const unitGroup = activeContent.querySelector(".sg_toggle_wrapper:nth-child(1) .size_guide_group");
      if (!unitGroup) return;

      const activeUnitBtn = unitGroup.querySelector(".size_guide_active");
      if (!activeUnitBtn) return;

      const unit = activeUnitBtn.textContent.trim(); // cm | in

      activeContent.querySelectorAll(".size_guide_table tbody tr").forEach((row) => {
        row.querySelectorAll(".cm_in").forEach((cell) => {
          if (!cell.dataset.cm) {
            cell.dataset.cm = cell.textContent.trim();
          }

          if (unit === "cm") {
            cell.textContent = cell.dataset.cm;
          } else {
            cell.textContent = convertRange(cell.dataset.cm);
          }
        });
      });
    }, 50);
  });

  /* popup open re-init */
  document.addEventListener("click", function (e) {
    const popupTrigger = e.target.closest("[data-size-guide], .open-size-guide, .sg_open");
    if (!popupTrigger) return;

    setTimeout(() => {
      const popup = document.querySelector("#size_guide_popup");
      if (popup) {
        reInitIndicators(popup);
      }
    }, 100);
  });
}

function ShopNowLook() {
  if (!document.querySelector(".product_hotspots_wrapper")) return;
  let productHotspotsSlider = new Swiper(".products_hotspots_swiper", {
    slidesPerView: 1.1,
    spaceBetween: 4,
    centeredSlides: false,
    // initialSlide: 1,
    mousewheel: {
      forceToAxis: true, // Only respond to horizontal scroll
      releaseOnEdges: true,
      sensitivity: 0.5,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    //slideToClickedSlide: true,
    navigation: {
      nextEl: ".products_hotspots_button_next",
      prevEl: ".products_hotspots_button_prev",
    },
    breakpoints: {
      375: {slidesPerView: 1.2},
      576: {slidesPerView: 2},
      768: {slidesPerView: 2},
      992: {slidesPerView: 3},
      1200: {
        slidesPerView: 4,
        // simulateTouch: false, allowTouchMove: false, grabCursor: false
      },
    },
  });
document.querySelectorAll(".product_hotspots_wrapper").forEach((section) => {
  const hotspots = section.querySelectorAll(".shop-the-look__hot-spot");
  const cards = section.querySelectorAll("product-card.product_hotspot_card");
  const wrapper = section.querySelector(".shop-the-look__image-wrapper");

  const hideAll = () => {
    cards.forEach((card) => {
      card.style.opacity = "0";
      card.style.visibility = "hidden";
      card.style.pointerEvents = "none";
    });
    hotspots.forEach((h) => h.setAttribute("aria-current", "false"));
  };

  hotspots.forEach((hotspot, index) => {
    hotspot.addEventListener("click", (e) => {
      e.stopPropagation();

      const isActive = hotspot.getAttribute("aria-current") === "true";
      hideAll();

      if (isActive) return; // toggle off — we're done

      hotspot.setAttribute("aria-current", "true");
      const activeCard = cards[index];
      if (!activeCard || !wrapper) return;

      const topPercent = parseFloat(
        hotspot.style.getPropertyValue("--shop-the-look-hot-spot-top")
      );
      const leftPercent = parseFloat(
        hotspot.style.getPropertyValue("--shop-the-look-hot-spot-left")
      );

      // Reset all positioning first
      activeCard.style.cssText += `
        top: ${topPercent}%;
        left: ${leftPercent}%;
        bottom: auto;
        right: auto;
        transform: translate(-50%, 20px);
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
      `;

      // Wait for browser to paint before measuring
      requestAnimationFrame(() => {
        const cardRect = activeCard.getBoundingClientRect();
        const wrapperRect = wrapper.getBoundingClientRect();

        let translateX = "-50%";
        let translateY = "20px";

        // --- Vertical: flip above if overflows bottom ---
        if (cardRect.bottom > wrapperRect.bottom) {
          activeCard.style.top = "auto";
          activeCard.style.bottom = `${100 - topPercent}%`;
          translateY = "-100%"; // place fully above the hotspot
        }

        // --- Horizontal: clamp to wrapper edges ---
        if (cardRect.right > wrapperRect.right) {
          activeCard.style.left = "auto";
          activeCard.style.right = "0";
          translateX = "0";
        } else if (cardRect.left < wrapperRect.left) {
          activeCard.style.left = "0";
          translateX = "0";
        }

        activeCard.style.transform = `translate(${translateX}, ${translateY})`;
      });
    });
  });

  // Close when clicking outside the section entirely
  document.addEventListener("click", (e) => {
    if (!section.contains(e.target)) {
      hideAll();
    }
  });
});
}

//YOU MIGHT ALSO LIKE whishlist fixes
(function () {
  const selector = "product-list .wishlist-hero-custom-button";

  /**   * Helper function to dispatch the custom event   */
  function triggerWishlistEvent(element) {
    const ev = new CustomEvent("wishlist-hero-add-to-custom-element", {
      detail: element,
    });
    document.dispatchEvent(ev);
  }

  // 1. Run for existing elements on page load
  document.querySelectorAll(selector).forEach(triggerWishlistEvent);

  // 2. Set up MutationObserver to watch for changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" || mutation.type === "childList") {
        const target = mutation.target;
        // Check if the target itself matches or contains the selector
        if (target.nodeType === 1 && target.matches(selector)) {
          triggerWishlistEvent(target);
        } else if (target.nodeType === 1) {
          target.querySelectorAll(selector).forEach(triggerWishlistEvent);
        }
      }
    });
  });

  observer.observe(document.querySelector("main") || document.body, {
    childList: true,
    subtree: true,
  });
})();

if (document.querySelector(".pricing_swiper")) {
  let pricingSlider = new Swiper(".pricing_swiper", {
    slidesPerView: 1.1,
    spaceBetween: 16,
    centeredSlides: false,
    // initialSlide: 1,
    mousewheel: {
      forceToAxis: true, // Only respond to horizontal scroll
      releaseOnEdges: true,
      sensitivity: 0.5,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    pagination: {
      el: ".pricing_swiper_pagination",
      clickable: true,
    },
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".pricing_swiper_button_next",
      prevEl: ".pricing_swiper_button_prev",
    },
    breakpoints: {
      375: {slidesPerView: 1.2},
      576: {slidesPerView: 2},
      768: {slidesPerView: 2, spaceBetween: 24},
      992: {slidesPerView: 3},
    },
  });
}


function SlideshowHotspots() {
  console.log('SlideshowHotspots');
  document.querySelectorAll(".slideshow__hotspots-wrapper").forEach((wrapper) => {
    const hotspots = wrapper.querySelectorAll(".shop-the-look__hot-spot");
    const cards = wrapper.querySelectorAll("product-card.product_hotspot_card");

    const resetCard = (card) => {
      card.style.top = "";
      card.style.left = "";
      card.style.bottom = "";
      card.style.right = "";
      card.style.transform = "";
      card.style.opacity = "0";
      card.style.visibility = "hidden";
      card.style.pointerEvents = "none";
    };

    const hideAll = () => {
      cards.forEach(resetCard);
      hotspots.forEach((h) => h.setAttribute("aria-current", "false"));
    };

    hotspots.forEach((hotspot, index) => {
      hotspot.addEventListener("click", (e) => {
        e.stopPropagation();

        const isActive = hotspot.getAttribute("aria-current") === "true";
        hideAll();
        if (isActive) return; // toggled off — done

        hotspot.setAttribute("aria-current", "true");
        const activeCard = cards[index];
        if (!activeCard) return;

        // Read the resolved position (desktop or mobile, chosen by the CSS media query)
        const hotspotStyle = getComputedStyle(hotspot);
        const topPercent = parseFloat(hotspotStyle.getPropertyValue("--shop-the-look-hot-spot-top"));
        const leftPercent = parseFloat(hotspotStyle.getPropertyValue("--shop-the-look-hot-spot-left"));

        // Place it fully reset — no leftover top/bottom/left/right from a previous open
        activeCard.style.top = `${topPercent}%`;
        activeCard.style.left = `${leftPercent}%`;
        activeCard.style.bottom = "auto";
        activeCard.style.right = "auto";
        activeCard.style.transform = "translate(-50%, 20px)";
        activeCard.style.visibility = "visible";
        activeCard.style.pointerEvents = "auto";
        // opacity stays 0 until we've placed + flipped it, so it never flashes at the wrong size/spot

        requestAnimationFrame(() => {
          const cardRect = activeCard.getBoundingClientRect();
          const wrapperRect = wrapper.getBoundingClientRect();

          let translateX = "-50%";
          let translateY = "20px";

          if (cardRect.bottom > wrapperRect.bottom) {
            activeCard.style.top = "auto";
            activeCard.style.bottom = `${100 - topPercent}%`;
            translateY = "-100%";
          }

          if (cardRect.right > wrapperRect.right) {
            activeCard.style.left = "auto";
            activeCard.style.right = "0";
            translateX = "0";
          } else if (cardRect.left < wrapperRect.left) {
            activeCard.style.left = "0";
            translateX = "0";
          }

          activeCard.style.transform = `translate(${translateX}, ${translateY})`;
          activeCard.style.opacity = "1";
        });
      });
    });

    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) hideAll();
    });
  });
}






/**
 * Positions marketing cards inside product grids.
 *
 * Marketing cards (see sections/main-collection.liquid) are rendered once, hidden, with a
 * `data-marketing-position` attribute holding their intended slot number. That number refers to
 * a slot among *actually rendered* product cards, not a raw product/pagination index, since
 * products can be skipped server-side (unavailable, hidden, out of stock, etc). This keeps the
 * card's placement correct no matter how many products got filtered out before it, and lets it
 * appear later once enough product cards exist (e.g. as more load in).
 */
function positionMarketingCards(root) {
  const marketingCards = root.querySelectorAll(":scope > [data-marketing-position]");
  if (marketingCards.length === 0) {
    return;
  }

  const productCards = Array.from(root.querySelectorAll(":scope > product-card:not([data-marketing-position])"));

  Array.from(marketingCards)
    .sort((a, b) => Number(a.dataset.marketingPosition) - Number(b.dataset.marketingPosition))
    .forEach((card) => {
      const position = Number(card.dataset.marketingPosition);
      if (!Number.isFinite(position) || position < 1) {
        return;
      }

      const anchor = productCards[position - 1];
      if (!anchor) {
        card.hidden = true;
        return;
      }

      if (card.previousElementSibling !== anchor) {
        anchor.after(card);
      }
      card.hidden = false;
    });
}

function positionAllMarketingCards() {
  document.querySelectorAll("product-list").forEach(positionMarketingCards);
}

positionAllMarketingCards();

// Re-run whenever a product grid changes: a facet/pagination AJAX swap replaces the whole
// section, and infinite scroll appends more product cards into the existing grid. Both show up
// as childList mutations, so a single subtree observer covers both without depending on either
// mechanism directly.
new MutationObserver(() => positionAllMarketingCards()).observe(document.body, {
  childList: true,
  subtree: true,
});